const defaultTheme = {
  color1: '#93C051',
  color2: '#197ACF',
  color3: '#297f0d',
  color4: '#888',
  color5: '#efefef',
  color6: '#aaa',
  color7: '#93C051',
  color8: '#F7A005',
  color9: '#404040',

  button: {
    colors: {
      primary: {
        bg: '#93C051',
        font: '#fff',
      },
      default: {
        bg: '#d6d6d6',
        font: '#787878',
      },
      success: {
        bg: '#0a0',
        font: '#fff',
      },
      danger: {
        bg: '#a00',
        font: '#fff',
      },
      warning: {
        bg: '#aa0',
        font: '#fff',
      },
      info: {
        bg: '#69f',
        font: '#fff',
      },
    },
    sizes: {
      small: {
        padding: '0 10px',
        fontSize: '13px',
        height: '24px',
      },
      default: {
        padding: '0 15px',
        fontSize: '14px',
        height: '32px',
      },
      large: {
        padding: '0 20px',
        fontSize: '15px',
        height: '40px',
      },
    },
  },
};

export default defaultTheme;
